export default __webpack_public_path__ + "static/media/fabula_desk_banner_3.59ff5e87.png";